function processPlayerStats(stats = {}, projections = {}) {
  for(const [key, v] of Object.entries(projections)) {
    stats[`proj_${key}`] = v
  }
  return stats
}

function makePrice({ player, price, stats, match }) {
  const priced = price?.[match]?.price
  if(priced) return priced
  const salary = player?.stats?.proj_salary
  if(salary) return +(Math.max(salary * 0.002, 12.00)).toFixed(2)
  return null
}

export default {
  processPlayerStats,
  makePrice,
};
